import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const menuItems = [
    {
        category: 'Backgrounds',
        items: [
            { name: 'Grid Background', path: '/components/grid-background' },
        ]
    },
    {
        category: 'Text',
        items: [
            { name: 'Variable Proximity', path: '/components/variable-proximity' },
            { name: 'Shuffle', path: '/components/shuffle' },
            { name: 'Text Pressure', path: '/components/text-pressure' },
            { name: 'Text Cursor', path: '/components/text-cursor' },
            { name: 'Scroll Reveal', path: '/components/scroll-reveal' },
            { name: 'Scrambled Text', path: '/components/scrambled-text' },
        ]
    },
    {
        category: 'Animations',
        items: [
            { name: 'Page Transition', path: '/components/page-transition' },
            { name: 'Folder', path: '/components/folder' },
            { name: 'Liquid Folder', path: '/components/liquid-folder' },
            { name: 'Pixel Transition', path: '/components/pixel-transition' },
            { name: 'Laser Flow', path: '/components/laser-flow' },
            { name: 'Magnet Lines', path: '/components/magnet-lines' },
            { name: 'Ghost Cursor', path: '/components/ghost-cursor' },
            { name: 'Cubes', path: '/components/cubes' },
            { name: 'Image Trail', path: '/components/image-trail' },
            { name: 'Scroll Stack', path: '/components/scroll-stack' },
            { name: 'Glass Surface', path: '/components/glass-surface' },

        ]
    },
    {
        category: 'Navbar',
        items: [
            { name: 'Bubble Menu', path: '/components/bubble-menu' },
            { name: 'Card Nav', path: '/components/card-nav' },
            { name: 'Glass Surface Navbar', path: '/components/glass-surface-navbar' },
        ]
    },
    {
        category: 'Gallery',
        items: [
            { name: 'Circular Gallery', path: '/components/circular-gallery' },
            { name: 'Stack', path: '/components/stack' },
            { name: 'Dome Gallery', path: '/components/dome-gallery' },
        ]
    },
    {
        category: 'Loaders',
        items: [
            { name: '3D Spinner', path: '/components/loader' },
        ]
    },
    {
        category: 'UI Elements',
        items: [
            { name: 'Buttons', path: '/components/buttons' },
            { name: 'Cards', path: '/components/cards' },
            { name: 'Inputs', path: '/components/inputs' },
            { name: 'Modals', path: '/components/modals' },
        ]
    }
];

const Sidebar = () => {
    const location = useLocation();

    return (
        <aside className="w-64 h-[calc(100vh-4rem)] sticky top-16 border-r border-white/10 bg-black/50 backdrop-blur-sm overflow-hidden hidden md:block">
            <div className="h-full overflow-y-auto pr-[17px] box-content">
                <div className="p-6 space-y-8 ">
                    {menuItems.map((section) => (
                        <div key={section.category}>
                            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3 px-2">
                                {section.category}
                            </h3>
                            <ul className="space-y-1">
                                {section.items.map((item) => {
                                    const isActive = location.pathname === item.path;
                                    return (
                                        <li key={item.name}>
                                            <Link
                                                to={item.path}
                                                className={`block px-3 py-2 rounded-lg text-sm transition-all duration-200 ${isActive
                                                    ? 'bg-white/10 text-white font-medium'
                                                    : 'text-gray-400 hover:text-white hover:bg-white/5'
                                                    }`}
                                            >
                                                {item.name}
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </aside>
    );
};

export default Sidebar;
